/**
 * Returns a trimmed absolute HTTP(S) URL, or `null` when the value is malformed
 * or uses an unsafe/unsupported protocol.
 */
export const getSafeHttpUrl = (value: string): string | null => {
    const trimmedValue = value.trim();

    try {
        const parsedUrl = new URL(trimmedValue);
        return parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:' ? trimmedValue : null;
    } catch {
        return null;
    }
};
